// video JS

$(document).on('click', '[data-video-url]', function(e){
  var $this = $(this)
        $(this).replaceWith($(`<iframe width=${$(this).width()} height=${$(this).height()} src="${ $(this).data('video-url')}?autoplay=1&origin=${window.location.href}" class="pl-md-4 px-4 w-100 embed-responsive-item" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` ));
});
